
import { Component, Prop, Vue } from 'vue-property-decorator'

import type { EventDetails } from '@/api/types/processedEntities'
import Subtitle from '@/components/elements/Subtitle.vue'
import { imageData } from '@/helpers/ImageHelpers'
import { stripTrustedHTML } from '@/helpers/StringHelpers'

@Component({
  name: 'EventListingItem',
  components: { Subtitle },
})
export default class extends Vue {
  @Prop()
  event: EventDetails

  @Prop()
  path: string

  get image() {
    return imageData(this.event, 'teaser')
  }

  get linkTitle() {
    return this.$t('linkTitle', { name: stripTrustedHTML(this.event.name) })
  }
}
